import { Component, computed, input, signal } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { KorviuInputComponent } from 'shared/components/korviu-input/korviu-input.component';
import {
  getTaxDocumentFormNameKey,
  getTaxDocumentResidencySuffixKey,
  TAX_DOCUMENT_ORIGINAL_FORM_URLS
} from '../tax-documentation-contract.helpers';

@Component({
  selector: 'app-tax-documentation-w8ben-certification-step',
  imports: [TranslatePipe, ReactiveFormsModule, KorviuInputComponent],
  templateUrl: './tax-documentation-w8ben-certification-step.component.html',
  styleUrl: '../tax-documentation-modal.component.scss'
})
export class TaxDocumentationW8benCertificationStepComponent {
  readonly originalFormUrl = TAX_DOCUMENT_ORIGINAL_FORM_URLS.W8BEN;
  readonly formNameKey = getTaxDocumentFormNameKey('W8BEN');
  readonly residencySuffixKey = getTaxDocumentResidencySuffixKey('W8BEN');

  form = input.required<FormGroup>();
  today = input.required<string>();
  isFullCertificationVisible = signal(false);

  iCertifyControl = computed(() => this.getFormControl('iCertify'));
  signerNameControl = computed(() => this.getControl('signerName'));

  showFullCertification(): void {
    this.isFullCertificationVisible.set(true);
  }

  private getControl(controlName: string): AbstractControl {
    return this.form().get(controlName);
  }

  private getFormControl(controlName: string): FormControl {
    return this.form().get(controlName) as FormControl;
  }
}
